import { createContext } from "react";

export default createContext({
    user: undefined,
    appointments: undefined,
    medicRecord: undefined,
    newPatient: true,
});